/* eslint-disable */
import { soapPost } from '../../ajaxSoap'
import { bizTypeMap } from '../../bizTypeMapping'
import { $notify, userInfo } from '../../../global'
import { i18n } from '../../i18n'
import { MasterPropertyType, InboundTypeValue, LotAttrCodeEnum } from '../bizEnum'
import { $Vue2Storage, StorageEnum } from '../../utils/storage/sessionStorage'
import { formatDate } from '../../utils/date'

//获取任务分配方式（自动，手动)byh
export const getTaskAssignMode = async (queryDoc) => {
    var ret = null
    await soapPost(bizTypeMap.queryAssignAutoMode, queryDoc)
      .done(function (data) {
        ret = data
      })
    return ret
  }
//获取波次时间
export const getSendTimes = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.getSendTimes, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
//获取承运商
export const getCarriers = async (queryDoc) => {
    var ret = null
    await soapPost(bizTypeMap.queryCarriers, queryDoc)
        .done(function (data) {
        ret = data
        })
    return ret
}
//获取配送方式
export const getDeliverys = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.qryDeliveryForList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
//获取个性化生产组
export const getProduces = async (queryDoc) => {
  var ret = null
  queryDoc.orgNo = userInfo.orgNo
  queryDoc.distributeNo = userInfo.distributeNo
  await soapPost(bizTypeMap.qryWkGrp, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
  // //生产方式
  // export const getProductionMode = async (queryDoc) => {
  //   var ret = null
  //   await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
  //     .done(function (data) {
  //       ret = data
  //     })
  //   return ret
  // }
  //获取货主
  export const getOwners = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.qryOwnerForList, queryDoc)
        .done(function (data) {
         ret = data
       })
      return ret
  }
//获取站点列表
export const getSites = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.qrySiteByNameForList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

//获取站点列表（分页，返回分页信息）
export const getSitesByPage = async (params) => {
  var ret = null
  await soapPost(bizTypeMap.qrySiteByNameForListWithPage, params)
    .done(function (data) {
      ret = data
    })
  return ret
}

//获取站点列表(任务分配)
export const getSitesForTask = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.qrySiteByNameForListForTask, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const splitBySkuAndCell = async (row) => {
  var ret = null
  await soapPost(bizTypeMap.splitBySkuAndCell,row)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const getAllUserListByLogicArea = async (row) => {
  var ret = null
  await soapPost(bizTypeMap.wms_authorityms_master_getAllUserListByLogicArea,row)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const generateTaskPageNo = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.generateTaskPageNo,queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const b2bDoTaskAssign = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.b2bDoTaskAssign,queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

  //获取逻辑区信息
  // export const getLogicAreas = async (queryDoc) => {
  //   var ret = null
  //   await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
  //     .done(function (data) {
  //       ret = data
  //     })
  //   return ret
  // }
  // //获取未分配的订单数量
  // export const getOutboundTypeCounts = async (queryDoc) => {
  //   var ret = null
  //   await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
  //     .done(function (data) {
  //       ret = data
  //     })
  //   return ret
  // }
  //获取单个集合单订单数量配置
  // export const getBatchOrderCount = async (queryDoc) => {
  //   var ret = null
  //   await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
  //     .done(function (data) {
  //       ret = data
  //     })
  //   return ret
  // }
  // //刷新数据
  // export const refreshData = async (queryDoc) => {
  //   var ret = null
  //   await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
  //     .done(function (data) {
  //       ret = data
  //     })
  //   return ret
  // }
   //通用合约
//   export const initCmbComContract = async (queryDoc) => {
//     var ret = null
//     await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
//       .done(function (data) {
//         ret = data
//       })
//     return ret
//   }
    //清关模式
  // export const initCustomModel = async (queryDoc) => {
  //   var ret = null
  //   await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
  //     .done(function (data) {
  //       ret = data
  //     })
  //   return ret
  // }
  //   //清关口岸
  // export const initCustomId = async (queryDoc) => {
  //   var ret = null
  //   await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
  //     .done(function (data) {
  //       ret = data
  //     })
  //   return ret
  // }
    //获取未分配的订单
    export const queryObShipmentMs = async (parameters) => {
      var ret = null
      await soapPost(bizTypeMap.queryObShipmentMs, parameters)
        .done(function (data) {
          ret = data
      })
      return ret
    }

    // 任务分配自动组波查询接口
    export const queryDynamicObShipmentMs = async (parameters) => {
      var ret = null
      await soapPost(bizTypeMap.queryDynamicObShipmentMs, parameters)
        .done(function (data) {
          ret = data
      })
      return ret
    }
    // 任务分配自动组波转手工任务接口
    export const doChangeDynamicObShipmentMsToTask = async (parameters) => {
      var ret = null
      await soapPost(bizTypeMap.doChangeDynamicObShipmentMsToTask, parameters, {noParseJson: true})
        .done(function (data) {
          ret = data
      })
      return ret
    }
    // 任务分配自动组波查询出库单的组单日志
    export const queryDynamicOperationLogOfOrder = async (parameters) => {
      var ret = null
      await soapPost(bizTypeMap.queryDynamicOperationLogOfOrder, parameters)
        .done(function (data) {
          ret = data
      })
      return ret
    }

    //获取未分配的订单id
    export const queryObShipmentMIds = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.queryObShipmentMIds, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //获取未分配的订单id
    export const totalPendingTasks = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.totalPendingTasks, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //获取配置查询
    export const getNoticeToAssignSwitch = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getNoticeToAssignSwitch, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //获取配置查询
    export const getExistPickTaskNeedAssign = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getExistPickTaskNeedAssign, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //获取未分配的订单id
    export const totalPendingSlots = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.totalPendingSlots, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //获取小黄人格口数量
    export const totalFreeSpace = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.totalFreeSpace, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //获取小黄人格口类型
    export const getAssignConfig = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getAssignConfig, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //获取任务分配锁
    export const getTaskAssignLock = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getTaskAssignLock, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //释放任务分配锁
    export const releaseTaskAssignLock = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.releaseTaskAssignLock, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //do任务分配
    export const doTaskAssign = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.doTaskAssign, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //请求货主
    export const queryOwnerNo = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.queryOwnerNo, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //请求尾程单号
    export const queryCarrierNo = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.queryCarrierNo, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    // 拣货任务单请求尾程
    export const getTaskLocateDList4CarrierNo = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getTaskLocateDList4CarrierNo, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
        
//doCC订单任务分配
    export const doCCTaskAssign = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.doCCTaskAssign, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
}
    //大波次订单任务分配
    export const doBigWaveTaskAssign = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.doBigWaveTaskAssign, queryDoc, {
        noShowError: true
      }).done(function (data) {
        ret = data
      })
      return ret
    }

    //获取定位----依据shipmentId获取任务定位详情
    export const getObLocateDs = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getObLocateDs, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //清理订单缓存
    export const clearCache = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.clearCache, queryDoc)
        .done(function (data) {
          ret = data
        })
      return ret
    }
    //强制解锁
    export const forceReleaseTaskAssignLock = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.forceReleaseTaskAssignLock, queryDoc)
      .done(function (data) {
        ret = data
      })
      return ret
    }
    //获取未分配的订单id
    export const getOutboundTypeCounts = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getOutboundTypeCounts, queryDoc)
      .done(function (data) {
        ret = data
      })
      return ret
    }

    //取消定位
    export const cancelLocateD = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.cancelLocateD, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const getGroupTaskRuleMListByPage = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getGroupTaskRuleMListByPage, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const getGroupTaskRuleM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getGroupTaskRuleM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const saveGroupTaskRuleM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.saveGroupTaskRuleM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const updateGroupTaskRuleM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.updateGroupTaskRuleM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const copyGroupTaskRuleM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.copyGroupTaskRuleM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const updateGroupTaskRuleMByStatus = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.updateGroupTaskRuleMByStatus, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const deleteGroupTaskRuleM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.deleteGroupTaskRuleM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const getDefaultGroupTaskRuleD = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getDefaultGroupTaskRuleD, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const getGroupTaskTemplateMListByParam = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getGroupTaskTemplateMListByParam, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }
    export const pageGroupTaskTemplateMListByParam = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.pageGroupTaskTemplateMListByParam, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const saveGroupTaskTemplateM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.saveGroupTaskTemplateM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const getGroupTaskTemplateM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getGroupTaskTemplateM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const updateGroupTaskTemplateM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.updateGroupTaskTemplateM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }
    
    export const updateGroupTaskTemplateMByStatus = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.updateGroupTaskTemplateMByStatus, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    export const deleteGroupTaskTemplateM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.deleteGroupTaskTemplateM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }
    
    export const updateGroupTaskTemplateMByTop = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.updateGroupTaskTemplateMByTop, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    // 动态组波监控数据查询
    export const getDynamicTaskForToday = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getDynamicTaskForToday, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    // 查询动态任务
    export const getDynamicTaskMListForToday = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getDynamicTaskMListForToday, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    // 查询动态任务明细
    export const getDynamicTaskDListForToday = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.getDynamicTaskDListForToday, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    // 重置任务
    export const resetDynamicTaskM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.resetDynamicTaskM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

    // 清空动态组波任务
    export const clearDynamicTaskM = async (queryDoc) => {
      var ret = null
      await soapPost(bizTypeMap.clearDynamicTaskM, queryDoc, {noParseJson: true}).done(function (data) {
        ret = data
      })
      return ret
    }

//请求客户打包方式
export const queryDistinctPackingRemark = async (queryDoc) => {
  let ret = null
  await soapPost(bizTypeMap.queryDistinctPackingRemark, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 获取流向
export const querySortingFlowName = async (queryDoc) => {
  let ret = null
  await soapPost(bizTypeMap.querySortingFlowName, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const queryZoneCode = async (queryDoc) => {
  let ret = null
  await soapPost(bizTypeMap.queryZoneCode, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}


//获取站点列表
export const getSiteSelector = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.getSiteSelector, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}